import request from '@/utils/request'
import qs from 'qs'

// 委托型号列表
export const getEnterpriseList = (params) => {
  return request({
    url: '/api/labOrder',
    method: 'GET',
    params:params,
    paramsSerializer: params => {
      return qs.stringify(params, {indices: false})
    }
  })
}
// 修改信息
export const changeData = (params) => {
  return request({
    url: '/api/labOrder',
    method: 'PUT',
    data: params
  })
}

// 订单详情
export const getEnterpriseDetail = (id) => {
    return request({
      url: '/api/labOrder/' + id,
      method: 'GET',
    })
}

// 委托单状态列表
export const getOrderStatusList = () => {
    return request({
      url: '/api/labOrder/state',
      method: 'GET',
    })
}

// 获取实验室列表
export const getDeptLabList = (name) => {
    return request({
      url: '/api/lab/chooseOrder?name=' + name,
      method: 'GET',
    })
}
// 创建订单
export const creatForm = (data) => {
    return request({
      url: '/api/labOrder',
      method: 'POST',
      data: data
    })
}
// 获取委托信息列表
export const getEntrustInfoList = () => {
    return request({
      url: '/api/entrustedInformation',
      method: 'GET',
    })
}
// 获取单条委托信息
export const getOneEntrustInfo = (data) => {
    return request({
      url: '/api/labOrder/entrustedInformation',
      method: 'PUT',
      data: data
    })
}

// 新增委托信息
export const newCreatEntrustInfo = (data) => {
    return request({
      url: '/api/entrustedInformation',
      method: 'POST',
      data: data
    })
}

// 删除样品信息
export const delEntrustInfo = (id) => {
    return request({
      url: '/api/entrustedInformation/' + id,
      method: 'DELETE',
    })
}

// 设为默认
export const setDefaultInfo = (id) => {
    return request({
      url: '/api/entrustedInformation/default/' + id,
      method: 'PUT',
    })
}
// 修改委托信息
export const changeEntrustInfo = (data) => {
    return request({
      url: '/api/entrustedInformation',
      method: 'PUT',
      data: data
    })
}

// 添加新样品信息
export const addNewSampleInfo = (data) => {
    return request({
      url: '/api/testSample',
      method: 'POST',
      data: data
    })
}


// 修改样品信息
export const changeSampleInfo = (data) => {
    return request({
      url: '/api/testSample',
      method: 'PUT',
      data: data
    })
}

// 删除样品信息
export const delSampleInfo = (id) => {
    return request({
      url: '/api/testSample/' + id,
      method: 'DELETE',
    })
}
// 提交委托单
export const submitForm = (id) => {
    return request({
      url: '/api/labOrder/submit/' + id,
      method: 'PUT',
    })
}

// 获取企业弹窗详情
export const getCompanyEntrustInfo = (id) => {
    return request({
      url: '/api/labOrder/enterprise/confirm/' + id,
      method: 'GET',
    })
}

// 企业确认委托单
export const companyConfirmEntrust = (data) => {
    return request({
      url: '/api/labOrder/enterprise/confirm',
      method: 'PUT',
      data: data
    })
}

// 获取实验室弹窗详情
export const getLabEntrustInfo = (id) => {
    return request({
      url: '/api/labOrder/lab/confirm/' + id,
      method: 'GET',
    })
}
// 实验室确认委托单
export const labConfirmEntrust = (data) => {
    return request({
      url: '/api/labOrder/lab/confirm',
      method: 'PUT',
      data: data
    })
}
// 新增委托单附件
export const newAddEntrustFile = (data) => {
    return request({
      url: '/api/labOrder/annex',
      method: 'POST',
      data: data
    })
}

// 新增报价单附件
export const newAddQuotationFile = (data) => {
    return request({
      url: '/api/labOrder/quotation/annex',
      method: 'POST',
      data: data
    })
}

// 删除报价单附件
export const deleteQuotationFile = (data) => {
    return request({
      url: '/api/labOrder/quotation/annex',
      method: 'DELETE',
      data: data
    })
}

// 删除委托单单附件
export const deleteEntrustFile = (data) => {
    return request({
      url: '/api/labOrder/annex',
      method: 'DELETE',
      data: data
    })
}
// 删除委托列表数据
export const delListData = (id) => {
  return request({
    url: '/api/labOrder/' + id,
    method: 'DELETE',
  })
}
// 新增报告附件
export const newAddReportFile = (data) => {
    return request({
      url: '/api/labOrder/report/annex',
      method: 'POST',
      data: data
    })
}

// 删除报告附件
export const deleteReportFile = (data) => {
    return request({
      url: '/api/labOrder/report/annex',
      method: 'DELETE',
      data: data
    })
}


// 上传报告确认
export const uploadReportComplete = (id) => {
    return request({
      url: '/api/labOrder/complete/' + id,
      method: 'PUT',
    })
}


// 改变收藏状态
export const changeLabCollectionStatus = (id) => {
    return request({
      url: '/api/lab/favorites/' + id,
      method: 'PUT',
    })
}


// 撤回委托单
export const labWithdraw = (id) => {
  return request({
    url: '/api/labOrder/withdraw/' + id,
    method: 'PUT',
  })
}


// 获取报告附件
export const lookReportAnnex = (id) => {
  return request({
    url: '/api/labOrder/report/annex/' + id,
    method: 'GET',
  })
}
// 获取制造商名称列表
export const getManufacturerList = () => {
  return request({
    url: '/api/labOrder/manufacturer',
    method: 'GET',
  })
}

// 选择制造商名称列表
export const getManufacturerName = (data) => {
  return request({
    url: '/api/labOrder/manufacturer/info',
    method: 'PUT',
    data: data
  })
}

// 下载报告附件
export const downloadReportFile = (id) => {
  return request({
    url: '/api/labOrder/printReport/' + id,
    method: 'GET',
    responseType: 'blob',
  })
}


// 新增认证检测附件
export const addNewAnnex = (data) => {
  return request({
    url: '/api/labOrder/authTesting/annex',
    method: 'POST',
    data: data
  })
}

// 删除认证检测附件
export const deleteAnnex = (data) => {
  return request({
    url: '/api/labOrder/authTesting/annex',
    method: 'DELETE',
    data: data
  })
}
// 获取变更委托单信息
export const getLabChangeInfo = (id) => {
  return request({
    url: '/api/labOrder/change/' + id,
    method: 'GET',
  })
}


// 实验室变更委托
export const labChangeSubmit = (data) => {
  return request({
    url: '/api/labOrder/change/lab',
    method: 'POST',
    data: data
  })
}

// 企业同意变更委托单
export const companyChangeSubmit = (id) => {
  return request({
    url: '/api/labOrder/change/enterprise/' + id,
    method: 'PUT',
  })
}

// 管理端垫付
export const adminChangeSubmit = (data) => {
  return request({
    url: '/api/labOrder/change/admin',
    method: 'PUT',
    data: data
  })
}


// 删除委托单
export const deleteEntrustForm = (id) => {
  return request({
    url: '/api/labOrder/' + id,
    method: 'DELETE',
  })
}

// 获取撤销变更信息
export const getRevokeInfo = (id) => {
  return request({
    url: '/api/labOrder/revoke/' + id,
    method: 'GET',
  })
}

// 撤销变更信息
export const revokeAction = (id) => {
  return request({
    url: '/api/labOrder/revoke/' + id,
    method: 'PUT',
  })
}

// 更改检测过程
export const modifyProcess = (data) => {
  return request({
    url: '/api/labOrder/process',
    method: 'PUT',
    data: data
  })
}

// 获取检测过程
export const showProcess = (id) => {
  return request({
    url: `/api/labOrder/showProcess/${id}`,
    method: 'GET',
  })
}

// 获取检测过程
export const labOrderExport = params => {
  return request({
    url: '/api/labOrder/export',
    method: 'GET',
    responseType: 'blob',
    params: params,
    paramsSerializer: params => {
      return qs.stringify(params, {indices: false})
    }
  })
}

// 企业上传付款凭证
export const uploadVoucher = ({labOrderId, fileId}) => {
  return request({
    url: `/api/labOrder/voucher/${labOrderId}/${fileId}`,
    method: 'POST',
  })
}

// 获取企业付款凭证及订单金额
export const getVoucher = id => {
  return request({
    url: `/api/labOrder/getVoucher/${id}`,
    method: 'GET',
  })
}

// 平台确认凭证
export const confirmVoucher = ({id, points}) => {
  return request({
    url: `/api/labOrder/confirm/${id}/${points}`,
    method: 'POST',
  })
}
